/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Color_PurpleInputs */

const en_booking_color_purple = /** @type {(inputs: Booking_Color_PurpleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purple`)
};

const pl_booking_color_purple = /** @type {(inputs: Booking_Color_PurpleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fioletowy`)
};

/**
* | output |
* | --- |
* | "Purple" |
*
* @param {Booking_Color_PurpleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_color_purple = /** @type {((inputs?: Booking_Color_PurpleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Color_PurpleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_color_purple(inputs)
	return en_booking_color_purple(inputs)
});